module.exports = __webpack_public_path__ + "img/payment-methods.a481727e.png";